class LaunchOffer {
  constructor(element) {
    this.element = element;
    this.countdownElement = this.element.querySelector('[data-countdown-end]');
    this.dropdownButton = this.element.querySelector('[data-dropdown-toggle]');
    this.dropdownMenu = this.element.querySelector('[data-dropdown-menu]');
    this.dropdownContainer = this.element.querySelector('[data-dropdown]');
    this.dropdownItems = this.element.querySelectorAll('.launch-offer__dropdown-item');
    this.selectedProductHandle = null;
    this.selectedProductVariantId = null;
    this.giftPrice = 0;
    this.isOfferUsed = false;
    this.limitToOne = this.element.dataset.limitToOne !== 'false';

    if (this.countdownElement) {
      this.endDate = new Date(this.countdownElement.dataset.countdownEnd).getTime();
      this.initCountdown();
    }

    // Check offer status BEFORE loading default product
    this.checkOfferStatus().then(() => {
      this.loadDefaultProduct();
    });

    if (this.dropdownButton && this.dropdownMenu) {
      this.initDropdown();
    }

    this.initAddToCartInterceptor();
    this.initCartListeners();
  }

  loadDefaultProduct() {
    if (!this.dropdownContainer) return;

    const defaultHandle = this.dropdownContainer.dataset.defaultProductHandle;
    const defaultVariantId = this.dropdownContainer.dataset.defaultProductVariantId;
    const defaultPrice = this.dropdownContainer.dataset.defaultProductPrice;

    if (defaultHandle && defaultVariantId && defaultPrice) {
      this.selectedProductHandle = defaultHandle;
      this.selectedProductVariantId = parseInt(defaultVariantId);
      this.giftPrice = parseInt(defaultPrice);
      this.updateComparePrice();
    }
  }

  initCountdown() {
    this.updateCountdown();
    this.countdownInterval = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance < 0) {
      clearInterval(this.countdownInterval);
      this.setCountdownValues(0, 0, 0, 0);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.setCountdownValues(days, hours, minutes, seconds);
  }

  setCountdownValues(days, hours, minutes, seconds) {
    const daysEl = this.countdownElement.querySelector('[data-days]');
    const hoursEl = this.countdownElement.querySelector('[data-hours]');
    const minutesEl = this.countdownElement.querySelector('[data-minutes]');
    const secondsEl = this.countdownElement.querySelector('[data-seconds]');

    if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
    if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  initDropdown() {
    this.dropdownButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleDropdown();
    });

    this.dropdownItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        this.selectProduct(item);
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.element.contains(e.target)) {
        this.closeDropdown();
      }
    });
  }

  toggleDropdown() {
    const isExpanded = this.dropdownButton.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.dropdownButton.setAttribute('aria-expanded', 'true');
    this.dropdownMenu.removeAttribute('hidden');
  }

  closeDropdown() {
    this.dropdownButton.setAttribute('aria-expanded', 'false');
    this.dropdownMenu.setAttribute('hidden', '');
  }

  async selectProduct(item) {
    const productTitle = item.dataset.productTitle;
    const productImage = item.dataset.productImage;
    const productHandle = item.dataset.productHandle;
    const selectedContainer = this.dropdownButton.querySelector('.launch-offer__dropdown-selected');

    this.selectedProductHandle = productHandle;

    try {
      const response = await fetch(`/products/${productHandle}.js`);
      const productData = await response.json();

      if (productData && productData.variants && productData.variants.length > 0) {
        this.selectedProductVariantId = productData.variants[0].id;
        this.giftPrice = productData.variants[0].price;
        this.updateComparePrice();
      }
    } catch (error) {
      console.error('Error fetching product data:', error);
    }

    if (!selectedContainer) {
      const placeholder = this.dropdownButton.querySelector('.launch-offer__placeholder');
      if (placeholder) {
        placeholder.outerHTML = `
          <div class="launch-offer__dropdown-selected">
            ${productImage ? `<img src="${productImage}" alt="${productTitle}" class="launch-offer__product-image" loading="lazy" width="40" height="40">` : ''}
            <span class="launch-offer__product-name p-medium fw-6">${productTitle}</span>
          </div>
        `;
      }
    } else {
      const imgEl = selectedContainer.querySelector('.launch-offer__product-image');
      const nameEl = selectedContainer.querySelector('.launch-offer__product-name');

      if (imgEl && productImage) {
        imgEl.src = productImage;
        imgEl.alt = productTitle;
      } else if (!imgEl && productImage) {
        selectedContainer.insertAdjacentHTML('afterbegin',
          `<img src="${productImage}" alt="${productTitle}" class="launch-offer__product-image" loading="lazy" width="40" height="40">`
        );
      }

      if (nameEl) {
        nameEl.textContent = productTitle;
      }
    }

    this.closeDropdown();
  }

  updateComparePrice() {
    // Don't update if offer is already used
    if (this.isOfferUsed) return;

    if (!this.giftPrice || this.giftPrice <= 0) return;

    const comparePriceElements = document.querySelectorAll('.product-form__compare-price');

    comparePriceElements.forEach(element => {
      if (!element.dataset.originalPrice) {
        element.dataset.originalPrice = element.textContent;
      }

      const originalPrice = parseInt(element.dataset.originalPrice.replace(/[^\d]/g, ''));
      const newTotalPrice = originalPrice + this.giftPrice;
      const formattedPrice = (newTotalPrice / 100).toFixed(2).replace('.', ',') + '€';

      element.textContent = formattedPrice;

      // Show the <s> tag
      const parent = element.parentElement;
      if (parent && parent.tagName === 'S') {
        parent.style.display = '';
      }
    });
  }

  initAddToCartInterceptor() {
    const addToCartButtons = document.querySelectorAll('.product-form__submit[data-action="add-to-cart"]');

    addToCartButtons.forEach(button => {
      button.addEventListener('click', async (e) => {
        if (this.selectedProductVariantId) {
          e.preventDefault();
          e.stopImmediatePropagation();

          await this.addBothProductsToCart(button);
        }
      }, true);
    });
  }

  async addBothProductsToCart(originalButton) {
    const variantId = originalButton.getAttribute('variant-id');
    const qty = originalButton.getAttribute('data-quantity') || 1;
    const properties = originalButton.getAttribute('data-properties')
      ? JSON.parse(originalButton.getAttribute('data-properties'))
      : null;

    const originalText = originalButton.innerHTML;
    originalButton.disabled = true;
    originalButton.setAttribute('aria-busy', 'true');
    originalButton.innerHTML = '<span class="fw-6">AJOUT...</span>';

    try {
      const randomId1 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      const finalProperties = { ...(properties || {}), _random: randomId1 };

      // Always add the discovery pack
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: qty,
          properties: finalProperties
        }),
        credentials: 'same-origin',
      });

      // Add the free gift ONLY if offer is not already used
      if (!this.isOfferUsed && this.selectedProductVariantId) {
        console.log('✅ Adding free gift with Launch Offer');
        const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            id: this.selectedProductVariantId,
            quantity: 1,
            properties: { '_gift': 'Launch Offer', '_random': randomId }
          }),
          credentials: 'same-origin',
        });
      } else {
        console.log('ℹ️ Offer already used, adding discovery pack only (no gift)');
      }

      originalButton.innerHTML = '<span class="fw-6">AJOUTÉ</span>';

      document.dispatchEvent(new CustomEvent('product:added'));

      const sideCart = document.querySelector('side-cart');
      if (sideCart) {
        sideCart.classList.add('open');
      }

      // Check offer status immediately after adding
      setTimeout(() => this.checkOfferStatus(), 800);

    } catch (error) {
      console.error('Error adding products to cart:', error);
      originalButton.innerHTML = originalText;
    } finally {
      originalButton.disabled = false;
      originalButton.removeAttribute('aria-busy');
      setTimeout(() => {
        originalButton.innerHTML = originalText;
      }, 1500);
    }
  }

  async checkOfferStatus() {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

      // List of possible gift handles (the 4 flavors)
      const giftHandles = ['caram-hellz', 'pop-pornz', 'fluffy-razberryz', 'speculooz-locoz'];

      // Check if there's a free gift (final_price = 0) OR with _gift property
      const hasLaunchOfferGift = cart.items.some(item => {
        const isFreeGift = giftHandles.includes(item.handle) && item.final_price === 0;
        const hasGiftProperty = item.properties && item.properties._gift === 'Launch Offer';
        return isFreeGift || hasGiftProperty;
      });

      // Check if discovery pack is in the cart
      const hasDiscoveryPack = cart.items.some(item =>
        item.handle.indexOf('decouverte') > -1
      );

      console.log('🔍 Offer status check:', { hasLaunchOfferGift, hasDiscoveryPack, limitToOne: this.limitToOne });

      // Offer is used only if limit is enabled AND BOTH gift AND discovery pack are in cart
      this.isOfferUsed = this.limitToOne && hasLaunchOfferGift && hasDiscoveryPack;

      // If gift exists but no discovery pack, remove the orphan gift
      if (hasLaunchOfferGift && !hasDiscoveryPack) {
        await this.removeOrphanGift(cart, giftHandles);
      }

      this.updateBlockState();
    } catch (error) {
      console.error('Error checking offer status:', error);
    }
  }

  async removeOrphanGift(cart, giftHandles) {
    try {
      // Find all Launch Offer gifts (free items OR with _gift property)
      const giftItems = cart.items.filter(item => {
        const isFreeGift = giftHandles.includes(item.handle) && item.final_price === 0;
        const hasGiftProperty = item.properties && item.properties._gift === 'Launch Offer';
        return isFreeGift || hasGiftProperty;
      });

      if (giftItems.length === 0) return;

      console.log('🗑️ Removing orphan Launch Offer gifts...', giftItems.map(i => i.title));

      // Build updates object to remove all gifts
      const updates = {};
      giftItems.forEach(item => {
        updates[item.key] = 0;
      });

      // Remove all gifts in one request
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      // Refresh sidecart to update UI
      const sideCart = document.querySelector('side-cart');
      if (sideCart && typeof sideCart.refreshCart === 'function') {
        await sideCart.refreshCart();
      }
    } catch (error) {
      console.error('Error removing orphan gift:', error);
    }
  }

  updateBlockState() {
    if (this.isOfferUsed) {
      this.disableBlock();
      // Force price update after a delay to ensure it takes effect
      setTimeout(() => this.updateButtonPriceWithoutGift(), 500);
      setTimeout(() => this.updateButtonPriceWithoutGift(), 1000);
    } else {
      this.enableBlock();
    }
  }

  disableBlock() {
    console.log('🔒 Disabling launch offer block');

    const wrapper = this.element.querySelector('.launch-offer__wrapper');
    if (!wrapper) return;

    // Add overlay with customizable text on the wrapper
    if (!wrapper.querySelector('.launch-offer__overlay')) {
      const overlayText = this.element.dataset.overlayText || 'Offre déjà utilisée !';

      const overlay = document.createElement('div');
      overlay.className = 'launch-offer__overlay';

      const textElement = document.createElement('div');
      textElement.className = 'launch-offer__overlay-text';
      textElement.textContent = overlayText;

      overlay.appendChild(textElement);
      wrapper.style.position = 'relative';
      wrapper.appendChild(overlay);
    }

    // Add additional text below wrapper (outside overlay)
    if (!this.element.querySelector('.launch-offer__additional-text')) {
      const additionalText = this.element.dataset.overlayAdditionalText || 'Mais tu peux quand même commander un deuxième coffret découverte';

      const textParagraph = document.createElement('p');
      textParagraph.className = 'launch-offer__additional-text p-small';
      textParagraph.textContent = additionalText;

      this.element.appendChild(textParagraph);
    }

    // Update button price immediately
    this.updateButtonPriceWithoutGift();

    // Disable interactions
    if (this.dropdownButton) {
      this.dropdownButton.disabled = true;
      this.dropdownButton.style.pointerEvents = 'none';
    }
  }

  enableBlock() {
    // Remove overlay
    const overlay = this.element.querySelector('.launch-offer__overlay');
    if (overlay) {
      overlay.remove();
    }

    // Remove additional text
    const additionalText = this.element.querySelector('.launch-offer__additional-text');
    if (additionalText) {
      additionalText.remove();
    }

    // Find all buttons and restore compare price display
    const buttons = document.querySelectorAll('.product-form__submit[data-action="add-to-cart"]');
    buttons.forEach(button => {
      const comparePriceEl = button.querySelector('.product-form__compare-price');
      if (comparePriceEl && comparePriceEl.parentElement.tagName === 'S') {
        comparePriceEl.parentElement.style.display = '';
      }
    });

    // Restore button price with gift
    this.updateComparePrice();

    // Enable interactions
    if (this.dropdownButton) {
      this.dropdownButton.disabled = false;
      this.dropdownButton.style.pointerEvents = '';
    }
  }

  updateButtonPriceWithoutGift() {
    console.log('🔒 Updating button price WITHOUT gift');

    // Find all buttons on the page
    const buttons = document.querySelectorAll('.product-form__submit[data-action="add-to-cart"]');
    console.log(`Found ${buttons.length} buttons to update`);

    buttons.forEach(button => {
      const originalPriceCents = parseInt(button.getAttribute('data-original-price'));
      if (!originalPriceCents) {
        console.log('⚠️ Button has no data-original-price, skipping');
        return;
      }

      console.log(`Button found with original price: ${originalPriceCents} cents`);

      // Hide compare price (crossed out price with gift)
      const comparePriceEl = button.querySelector('.product-form__compare-price');
      if (comparePriceEl) {
        const parent = comparePriceEl.parentElement;
        if (parent && parent.tagName === 'S') {
          parent.style.display = 'none';
          parent.style.visibility = 'hidden';
          console.log('✅ Hidden compare price (crossed out)');
        }
      } else {
        console.log('⚠️ No compare price element found');
      }

      // Update main price to show only pack price (without gift)
      const priceEl = button.querySelector('.product-form__price');
      if (priceEl) {
        const originalPrice = originalPriceCents / 100;
        const formattedPrice = new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR'
        }).format(originalPrice);
        priceEl.textContent = formattedPrice;
        console.log(`✅ Updated price to: ${formattedPrice}`);
      } else {
        console.log('⚠️ No price element found');
      }
    });
  }

  initCartListeners() {
    // Listen to product:added event
    document.addEventListener('product:added', () => {
      setTimeout(() => this.checkOfferStatus(), 1000);
    });

    // Listen to custom cart refresh event
    document.addEventListener('cart:refreshed', () => {
      setTimeout(() => this.checkOfferStatus(), 300);
    });
  }

  destroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}

function initLaunchOffers() {
  const launchOfferElements = document.querySelectorAll('.launch-offer');

  launchOfferElements.forEach(element => {
    if (!element.dataset.initialized) {
      new LaunchOffer(element);
      element.dataset.initialized = 'true';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLaunchOffers);
} else {
  initLaunchOffers();
}

document.addEventListener('shopify:section:load', initLaunchOffers);
